import { useState, useEffect } from 'react';

const useWidgetWidth = () => {
  const [widgetWidth, setWidgetWidth] = useState(getInitialWidgetWidth());

  useEffect(() => {
    function handleResize() {
      setWidgetWidth(getInitialWidgetWidth());
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return widgetWidth;
};

const getInitialWidgetWidth = () => {
  return (document.querySelectorAll('.storecashPdp_slider')[0].clientWidth) / 176;
};

export default useWidgetWidth;
